/**
 * Lazy loads img, background-image and iframes.
 * Skips lazy loading while in Sitefinity page editor.
 */
export const setupLazyLoad = (): void => {
  const lazyLoadingElements: NodeListOf<HTMLElement> =
    document.querySelectorAll("[data-lazy-load]");
  const loadedClass = "inView";

  const lazyElementObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry: IntersectionObserverEntry): void => {
      if (
        entry.isIntersecting &&
        !entry.target.classList.contains(loadedClass)
      ) {
        const element = entry.target as HTMLElement;
        loadElement(element);

        element.classList.add(loadedClass);
        lazyElementObserver.unobserve(element);
      }
    });
  });

  const loadElement = function (element: HTMLElement): void {
    const loadType: string | undefined = element.dataset.lazyLoad;
    const src: string | undefined = element.dataset.src;
    if (src) {
      switch (loadType) {
        case "img":
          (element as HTMLImageElement).src = src;
          break;
        case "iframe":
          (element as HTMLIFrameElement).src = src;
          break;
        case "background":
          element.style.backgroundImage = `url(${src})`;
          break;
        default:
          break;
      }
    }
  };

  lazyLoadingElements.forEach((element: HTMLElement): void => {
    const isPageEditor: boolean =
      document.body.classList.contains("-sf-new-zone-editor") ||
      document.body.classList.contains("sfPageEditor");
    if (isPageEditor) {
      loadElement(element);
    } else {
      lazyElementObserver.observe(element);
    }
  });
};
